import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog as MuiDialog,
} from "@mui/material";
import {
  useId,
  type AriaAttributes,
  type PropsWithChildren,
  type ReactNode,
} from "react";

export type DialogProps = Pick<AriaAttributes, "aria-label"> &
  PropsWithChildren<{
    isOpen: boolean;
    title?: ReactNode;
    onClose?: () => void;
    actions?: ReactNode;
  }>;

export function Dialog({
  isOpen,
  title,
  onClose,
  actions,
  children,
  ...props
}: DialogProps) {
  const titleId = useId();

  return (
    <MuiDialog
      aria-labelledby={title ? titleId : undefined}
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      {...props}
    >
      {title && <DialogTitle>{title}</DialogTitle>}

      <DialogContent>{children}</DialogContent>

      {actions ? <DialogActions>{actions}</DialogActions> : null}
    </MuiDialog>
  );
}
